import { Outlet } from "react-router-dom";
import styled from "styled-components";
import TimePicker from "../components/time-picker/time-picker.component";
import MessageError from "../components/errorMessage/error-modal-window.component";
import { useEffect, useState } from "react";

const CMLayout = styled.div`
  padding: ${(props) => props.theme.spacers.pageY} 0 0px 0;
  min-height:calc(100vh - 496px);
  @media ${(props) => props.theme.breakpoints.lg} {
    padding: 0 0;
  }
  @media ${(props) => props.theme.breakpoints.md} {
    padding: 0 0;
  }
  @media ${(props) => props.theme.breakpoints.sm} {
    padding: 0 0;
  }
`;


const MainLayout = () => {
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    const error = localStorage.getItem('apiError');
    if (error) {
      const errorData = JSON.parse(error);
      if (errorData.count === 4) {
        setShowError(true);
      } else {
        setShowError(false);
      }
    } else {
      setShowError(false);
    }
  }, []);

  return (
    <>
      <CMLayout>
        {showError && <MessageError />}
        {/*<TimePicker />*/}
        <Outlet />
      </CMLayout>
    </>
  );
};

export default MainLayout;
